export const getPointsTable = (division, pointsType) => {
  return require(`../assets/points-tables/division-${division}-${pointsType}-points.json`);
};